import { render } from "./TabelaMateriaisEntregues.vue?vue&type=template&id=73fafcf6"
import script from "./TabelaMateriaisEntregues.vue?vue&type=script&lang=js"
export * from "./TabelaMateriaisEntregues.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__